module.exports = __webpack_public_path__ + "img/vegetable-celery-root-190x100.5138b355.jpg";